import { createLucideIcon } from 'lucide-react';

const ShapesUploadIcon = createLucideIcon('ShapesUpload', [
  [
    'path',
    {
      d: 'M2.738 10C2.609 10.007 2.481 9.978 2.367 9.917 2.254 9.856 2.159 9.764 2.095 9.652 2.03 9.541 1.997 9.413 2 9.284 2.003 9.155 2.042 9.029 2.112 8.921L5.838 3C5.897 2.895 5.981 2.806 6.084 2.743 6.187 2.68 6.304 2.645 6.425 2.64 6.546 2.636 6.665 2.663 6.772 2.718 6.879 2.774 6.97 2.856 7.036 2.957L10.738 8.9C10.811 9.005 10.854 9.128 10.862 9.255 10.871 9.382 10.844 9.51 10.785 9.623 10.726 9.736 10.637 9.831 10.528 9.898 10.419 9.964 10.294 10 10.166 10H2.738ZM9 14H4C3.448 14 3 14.448 3 15V20C3 20.552 3.448 21 4 21H9C9.552 21 10 20.552 10 20V15C10 14.448 9.552 14 9 14ZM17 10C18.933 10 20.5 8.433 20.5 6.5 20.5 4.567 18.933 3 17 3 15.067 3 13.5 4.567 13.5 6.5 13.5 8.433 15.067 10 17 10ZM14 17 17 14 20 17M17 21V14.5',
      key: '1',
    },
  ],
]);

ShapesUploadIcon.displayName = 'ShapesUploadIcon';

export default ShapesUploadIcon;
